import PropTypes from 'prop-types';
import { useTranslation } from 'next-i18next';
import format from 'date-fns/format';

import HTMLRenderer from '@common/components/CMSComponents/HTMLRenderer';
import { ArrowExternal } from '@common/components/Icons';
import { DAY_MONTH_YEAR_DOTS } from '@common/constants/dates';

import {
  Container,
  Description,
  Item,
  ItemButton,
  ItemDate,
  ItemsContainer,
  ItemText,
  ItemTitle,
  Title,
} from './PressStatementsList.styled';

const PressStatementsList = ({ value }) => {
  const { title, items, description } = value;
  const { t } = useTranslation();

  return (
    <Container>
      <Title>{title}</Title>
      <ItemsContainer>
        {items.map(item => {
          const date = new Date(item.date);

          return (
            <Item key={`${item.title}_${item.date}`}>
              <ItemDate>{format(date, DAY_MONTH_YEAR_DOTS)}</ItemDate>
              <ItemTitle>{item.title}</ItemTitle>
              <ItemText>
                <HTMLRenderer html={item.text} />
              </ItemText>
              <ItemButton
                href={item.url}
                target="_blank"
                rel="noopener noreferrer"
                iconRight={<ArrowExternal />}
              >
                {t(
                  'cmsBlock.pressStatementsList.item.linkText',
                  'Mitteilung lesen',
                )}
              </ItemButton>
            </Item>
          );
        })}
      </ItemsContainer>
      <Description>
        <HTMLRenderer html={description} />
      </Description>
    </Container>
  );
};

PressStatementsList.propTypes = {
  value: PropTypes.shape({
    description: PropTypes.string,
    items: PropTypes.arrayOf(
      PropTypes.shape({
        date: PropTypes.string,
        text: PropTypes.string,
        title: PropTypes.string,
        url: PropTypes.string,
      }),
    ),
    title: PropTypes.string,
  }).isRequired,
};

export default PressStatementsList;
